import React from 'react'
import { IconSVGType } from '../../../types/icons'

export const JCBCardWhiteIcon = (props: IconSVGType) => {
  return (
    <svg
      width='24'
      height='18'
      viewBox='0 0 24 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1412_4041)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.90116 1.52588e-05C1.37984 0.0299505 0.00322997 1.38723 0.00322997 2.90755C0.00322997 3.75338 0.00258398 7.10167 0.00193798 10.4302C0.284238 10.6054 1.64276 11.0353 2.18928 11.0729C3.38566 11.1569 4.1279 10.7671 4.24289 9.78374L4.23708 6.13164H6.88307V9.7003C6.74483 11.7435 4.92571 12.1607 2.15762 12.0231C1.44121 11.9868 0.467054 11.8053 0.00129199 11.6856C0.000645994 15.0167 0 18 0 18H4.60659C5.86369 18 7.5 16.8421 7.5 15.081V1.52588e-05H2.90116Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.90116 1.52588e-05C1.37984 0.0299505 0.00322997 1.38723 0.00322997 2.90755C0.00322997 3.75338 0.00258398 7.10167 0.00193798 10.4302C0.284238 10.6054 1.64276 11.0353 2.18928 11.0729C3.38566 11.1569 4.1279 10.7671 4.24289 9.78374L4.23708 6.13164H6.88307V9.7003C6.74483 11.7435 4.92571 12.1607 2.15762 12.0231C1.44121 11.9868 0.467054 11.8053 0.00129199 11.6856C0.000645994 15.0167 0 18 0 18H4.60659C5.86369 18 7.5 16.8421 7.5 15.081V1.52588e-05H2.90116Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.1505 0C9.62984 0.0299352 8.25258 1.38721 8.25258 2.90754C8.25258 3.44319 8.25258 4.98453 8.25194 6.88765C9.17636 6.17557 10.6673 5.82654 12.564 5.97049C13.6428 6.05201 14.4412 6.20041 14.8766 6.32716V7.59081C14.3966 7.35451 13.4503 7.00293 12.6602 6.94752C10.8714 6.82014 9.93282 7.64686 9.93282 8.98248C9.93282 10.1843 10.6576 11.2136 12.6525 11.0767C13.3101 11.0315 14.405 10.6538 14.8708 10.4353L14.8766 11.6607C14.4754 11.7849 13.228 12.0531 12.0536 12.0626C10.2868 12.0766 9.03941 11.7066 8.25129 11.106C8.25 14.6625 8.25 18 8.25 18H12.8559C14.113 18 15.75 16.8421 15.75 15.081V0H11.1505Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.1505 0C9.62984 0.0299352 8.25258 1.38721 8.25258 2.90754C8.25258 3.44319 8.25258 4.98453 8.25194 6.88765C9.17636 6.17557 10.6673 5.82654 12.564 5.97049C13.6428 6.05201 14.4412 6.20041 14.8766 6.32716V7.59081C14.3966 7.35451 13.4503 7.00293 12.6602 6.94752C10.8714 6.82014 9.93282 7.64686 9.93282 8.98248C9.93282 10.1843 10.6576 11.2136 12.6525 11.0767C13.3101 11.0315 14.405 10.6538 14.8708 10.4353L14.8766 11.6607C14.4754 11.7849 13.228 12.0531 12.0536 12.0626C10.2868 12.0766 9.03941 11.7066 8.25129 11.106C8.25 14.6625 8.25 18 8.25 18H12.8559C14.113 18 15.75 16.8421 15.75 15.081V0H11.1505Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.4005 0C17.8805 0.0299352 16.5026 1.38721 16.5026 2.90754C16.5026 3.36803 16.5026 4.57117 16.5026 6.10742H20.8811C21.7526 6.10742 22.7791 6.47493 22.7791 7.51884C22.7791 8.07933 22.4767 8.71434 21.3857 8.91942V8.94363C22.0226 8.94363 23.1266 9.31113 23.1266 10.4194C23.1266 11.5633 21.9341 11.8811 21.2952 11.8811L16.5013 11.8862C16.5006 15.1358 16.5 18 16.5 18H21.1066C22.3637 18 24 16.8421 24 15.081V0H19.4005Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.4005 0C17.8805 0.0299352 16.5026 1.38721 16.5026 2.90754C16.5026 3.36803 16.5026 4.57117 16.5026 6.10742H20.8811C21.7526 6.10742 22.7791 6.47493 22.7791 7.51884C22.7791 8.07933 22.4767 8.71434 21.3857 8.91942V8.94363C22.0226 8.94363 23.1266 9.31113 23.1266 10.4194C23.1266 11.5633 21.9341 11.8811 21.2952 11.8811L16.5013 11.8862C16.5006 15.1358 16.5 18 16.5 18H21.1066C22.3637 18 24 16.8421 24 15.081V0H19.4005Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.978 9.36527L17.9747 10.9557L19.7784 10.962C20.1291 10.962 20.5703 10.6652 20.5703 10.1493C20.5703 9.69328 20.1892 9.36209 19.7809 9.36527C19.5245 9.36846 19.1117 9.36718 18.7435 9.36591C18.5193 9.36527 18.3113 9.36463 18.164 9.36463C18.0781 9.36463 18.0135 9.36463 17.978 9.36527Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.978 9.36527L17.9747 10.9557L19.7784 10.962C20.1291 10.962 20.5703 10.6652 20.5703 10.1493C20.5703 9.69328 20.1892 9.36209 19.7809 9.36527C19.5245 9.36846 19.1117 9.36718 18.7435 9.36591C18.5193 9.36527 18.3113 9.36463 18.164 9.36463C18.0781 9.36463 18.0135 9.36463 17.978 9.36527Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.9715 7.01885L17.9657 8.46657L19.6692 8.47867C19.9535 8.47294 20.3507 8.2169 20.3507 7.76978C20.3507 7.31311 20.0032 7.00548 19.6337 7.01376C19.3921 7.01949 19.0613 7.01694 18.7558 7.01439C18.5917 7.01312 18.4347 7.01185 18.3029 7.01185C18.1498 7.01185 18.0303 7.01376 17.9715 7.01885Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.9715 7.01885L17.9657 8.46657L19.6692 8.47867C19.9535 8.47294 20.3507 8.2169 20.3507 7.76978C20.3507 7.31311 20.0032 7.00548 19.6337 7.01376C19.3921 7.01949 19.0613 7.01694 18.7558 7.01439C18.5917 7.01312 18.4347 7.01185 18.3029 7.01185C18.1498 7.01185 18.0303 7.01376 17.9715 7.01885Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1412_4041'>
          <rect width='24' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
